import { LogOut } from 'lucide-react';
import { useVisit } from '../../VisitContext';
import { Button } from '~/shared/components/buttons/Button';
import { useEndVisit } from '../../mutations';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';

export function EndVisitButton() {
	const { id } = useVisit();
	const { handleEndVisit, isPending } = useEndVisit(id);

	const onEndVisit = () => {
		handleEndVisit();
	};

	return (
		<FooterButtonContainer>
			<Button onClick={onEndVisit} isPending={isPending} Icon={LogOut} label="End Visit" />
		</FooterButtonContainer>
	);
}
